import React from 'react'
import { Flex, Hover, Icon } from '@Common/Components'
import state from '../../State'
import { addService } from '../../Functions'
const iconSize = 35

const BarBottom = () => {
  const { hover, circle } = styles
  const [moneyForm] = state.moneyForm.useState()
  return (
    <Flex row style={{ marginBottom: 35, marginTop: 35 }}>
      <Hover style={hover}>
        <Icon
          name='hotel' text='Hotel' style={circle} textStyle={styles.textStyle} badgeSize={30}
          badge='+' size={iconSize} onClick={() => addService('hotelForm')}
        />
      </Hover>
      <Hover style={hover}>
        <Icon
          name='plane' text='Voli' style={circle} badge='+' badgeSize={30}
          size={iconSize} onClick={() => addService('flightForm')} textStyle={styles.textStyle}
        />
      </Hover>
      <Hover style={hover}>
        <Icon
          name='train' text='Treni' style={circle} badge='+' badgeSize={30}
          size={iconSize} onClick={() => addService('trainForm')} textStyle={styles.textStyle}
        />
      </Hover>
      <Hover style={hover}>
        <Icon
          name='car' text='Auto' style={circle} badge='+' badgeSize={30}
          size={iconSize} onClick={() => addService('carForm')} textStyle={styles.textStyle}
        />
      </Hover>
      <Hover style={hover}>
        <Icon
          name='ticket' text='Altro' style={circle} badge='+' badgeSize={30}
          size={iconSize} onClick={() => addService('serviceForm')} textStyle={styles.textStyle}
        />
      </Hover>
      <Hover style={hover}>
        <Icon
          name='cruise' text='Nave' style={circle} badge='+' badgeSize={30}
          size={iconSize} onClick={() => addService('cruiseForm')} textStyle={styles.textStyle}
        />
      </Hover>

      <Hover style={hover}>
        <Icon
          name='add-person' text='Passeggeri' style={circle} badge='+' badgeSize={30}
          size={iconSize} onClick={() => addService('passengers')} textStyle={{ ...styles.textStyle, color: 'white' }}
        />
      </Hover>

      {moneyForm?.length < 1 && (
        <Hover style={hover}>
          <Icon
            name='money' text='Contabilità' style={circle} badge='+' badgeSize={30}
            size={iconSize} onClick={() => addService('moneyForm')} textStyle={{ ...styles.textStyle, color: 'white' }}
          />
        </Hover>
      )}
    </Flex>
  )
}

const styles = {
  hover: {
    width: 80,
    height: 80,
    margin: 10,
    marginBottom: 30
  },
  circle: {
    borderRadius: '50%',
    width: 70,
    height: 70,
    backgroundColor: 'white',
    color: 'white'
  },
  textStyle: {
    marginLeft: -10,
    color: 'white'
  }
}

export default BarBottom
